export default "__VITE_ASSET__BRrqCATV__"